import React, { Component } from "react";
import { resolve } from "../factories/ComponentsFactory";
import utils from "./UtilityService";
import webuiState from "./InternalStateService";
import translationService from "./TranslationService";
import ControlMessagesNew from "@tinqin/tinqin-ui-components/src/control-messages/ControlMessages";
import ControlMessageGroupNew from "@tinqin/tinqin-ui-components/src/control-messages/ControlMessageGroup";
import Paragraph from "@tinqin/tinqin-ui-components/src/paragraph/Paragraph";
import containerUtils from "../utils/containerUtils";

export class ReduxWidget extends Component {
    componentDidCatch(error, info) {
        let widgetState = {
            state: "error",
            message: translationService.translate("renderErrorMessage")
        };
        this.props.setWidgetErrorState(this.props.widgetId, widgetState);
    }

    //adding widget refresh on window size changes
    //TODO: data loss issue to be checked
    componentDidUpdate(prevProps) {
        if (this.props.config.reloadOnResize) {
            if (prevProps.windowSizeCategory !== this.props.windowSizeCategory) {
                this.props.reloadWidgetConfigData({
                    parentWidget: this.props.parentWidget,
                    ...this.props.config
                });
            }
        }
    }

    buildChildren() {
        let children = this.props.config.components || [];
        let widgetId = this.props.id;
        if (children.length) {
            return children.map((child, index) => {
                return resolve(child, {
                    widgetId,
                    key: index
                });
            });
        }
        return [];
    }

    render() {
        let children = [];
        let data = this.props.data || {};
        let config = this.props.config || {};
        let uiState = this.props.uiState || {};

        let props = containerUtils.extractComponentProps(this.props, {
            additionalProps: [
                "extraClasses",
                "visible",
                "resolveWhenHidden",
                "cached",
                "loadingType",
                "loadingMinHeight"
            ],
            propsDefaults: { visible: true }
        });

        if (!props.visible && !props.resolveWhenHidden) {
            return null;
        }

        //in case critical messages has been triggered inside the widget
        let hasWidgetMessages = data.widgetState;
        if (hasWidgetMessages) {
            return (
                <ControlMessagesNew extraClasses="tq-gutter-all">
                    <ControlMessageGroupNew
                        groupType={data.widgetState.state}
                        name={translationService.translate(data.widgetState.state)}
                    >
                        <Paragraph text={data.widgetState.message} />
                    </ControlMessageGroupNew>
                </ControlMessagesNew>
            );
        }

        let missingData = !this.props.data || !this.props.config;

        if (!missingData) {
            children = this.buildChildren();
        }

        let widgetClasses = "";
        widgetClasses += !props.visible ? "tq-hide " : "";
        widgetClasses += config.extraClasses ? config.extraClasses : "";
        if (widgetClasses) {
            children = <div className={widgetClasses}>{children}</div>;
        }

        //application global property - legacyWidgetLoadingAnimation
        //by default no widget loading animation container
        const widgetLoading = webuiState.getGlobalProperties("widgetLoadingAnimation");
        if (widgetLoading) {
            let WidgetLoadingAnimation = webuiState.getComponent("widgetLoading");
            let isCached = props.cached;
            let isLoading = uiState.loading;
            //Loading animation type, only "none" so far
            let loadingType = props.loadingType || false;
            let noLoading = loadingType === "none";
            //will not show loading in case disabled (noLoading)
            //shows loading in case uiSate flag is set and the widget is not cached
            //or the widget is cached but data is missing(initial render)
            let showLoading = !noLoading && isLoading && (!isCached || missingData);
            let loadingProp = {
                isLoading: showLoading
            };
            let loadingMinHeight = props.loadingMinHeight;
            if (loadingMinHeight) {
                loadingProp.minHeight = loadingMinHeight;
            }

            return <WidgetLoadingAnimation {...loadingProp}>{children}</WidgetLoadingAnimation>;
        }

        return children;
    }
}

export default utils.connectWidget({
    loadWidget: "widget.loadWidget",
    setWidgetErrorState: "widget.setWidgetErrorState",
    reloadWidgetConfigData: "widget.reloadWidgetConfigData"
})(ReduxWidget);
